//------------------------------------------------------------------------------
// name: WithdrawChannelLabel.tsx
// author: mudas
// created: 2025/12/03
//------------------------------------------------------------------------------

import React, { CSSProperties, FC, ReactNode } from 'react';
import { isNil } from 'lodash-es';
import { useComputed } from 'common/hooks';

import { WithdrawChannel, WithdrawChannelName } from 'common/types';
import { Icon } from '@fuxi/eevee-ui';

export interface IProps {
  type?: WithdrawChannel;

  // 一般情况下，icon 会随 type 自动获取，不需要自定义
  // 但是有些场景下，icon 可以被强制覆盖
  // 设置为 null 不显示图标
  icon?: ReactNode | null;

  // 仅在 type 为 WithdrawChannel.BankCard 时生效，用于区分国内和国外银行卡
  abroad?: boolean;

  className?: string;
  style?: CSSProperties;
}

const WithdrawChannelLabel: FC<IProps> = (props) => {
  const { icon, type, abroad, className, style } = props;

  const iconNode = useComputed<ReactNode>(() => {
    switch (type) {
      case WithdrawChannel.Alipay: {
        return <Icon name="alipay" className="color-blue-6" />;
      }
      case WithdrawChannel.BankCard: {
        return <Icon name={abroad ? 'international-bank-card' : 'bankpay'} />;
      }
      case WithdrawChannel.Offline: {
        return <Icon name="offlinepay" className="c-primary" />;
      }
    }
  }, [type, abroad]);

  return (
    <div className={`flex items-center gap-1 ${className}`} style={style}>
      {icon === null ? null : icon || iconNode}
      {!isNil(type) ? WithdrawChannelName[type] : '未知渠道'}
    </div>
  );
};

export default WithdrawChannelLabel;
